module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card is-large"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [(_vm.error !== '') ? _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provider.status),
      expression: "provider.status"
    }],
    staticClass: "select is-fullwidth",
    attrs: {
      "name": "status",
      "id": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.provider, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Prospection")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Negotiation")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inactive")])])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Commecial Representative")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provider.commecial_representative),
      expression: "provider.commecial_representative"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "commecial_representative",
      "id": "commecial_representative"
    },
    domProps: {
      "value": (_vm.provider.commecial_representative)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.provider, "commecial_representative", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Account Executive")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provider.account_executive),
      expression: "provider.account_executive"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "account_executive",
      "id": "account_executive"
    },
    domProps: {
      "value": (_vm.provider.account_executive)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.provider, "account_executive", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Observation")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provider.relationship_obs),
      expression: "provider.relationship_obs"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "relationship_obs",
      "id": "relationship_obs"
    },
    domProps: {
      "value": (_vm.provider.relationship_obs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.provider, "relationship_obs", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provider.contract_arrived),
      expression: "provider.contract_arrived"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.provider.contract_arrived) ? _vm._i(_vm.provider.contract_arrived, null) > -1 : (_vm.provider.contract_arrived)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.provider.contract_arrived,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.provider, "contract_arrived", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.provider, "contract_arrived", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.provider, "contract_arrived", $$c)
        }
      }
    }
  }), _vm._v("\n          Contract arrived at the company\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provider.firm_recognized),
      expression: "provider.firm_recognized"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.provider.firm_recognized) ? _vm._i(_vm.provider.firm_recognized, null) > -1 : (_vm.provider.firm_recognized)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.provider.firm_recognized,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.provider, "firm_recognized", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.provider, "firm_recognized", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.provider, "firm_recognized", $$c)
        }
      }
    }
  }), _vm._v("\n          Firm recognized\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provider.forwarded_supplier),
      expression: "provider.forwarded_supplier"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.provider.forwarded_supplier) ? _vm._i(_vm.provider.forwarded_supplier, null) > -1 : (_vm.provider.forwarded_supplier)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.provider.forwarded_supplier,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.provider, "forwarded_supplier", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.provider, "forwarded_supplier", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.provider, "forwarded_supplier", $$c)
        }
      }
    }
  }), _vm._v("\n          Forwarded to the supplier\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provider.archived),
      expression: "provider.archived"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.provider.archived) ? _vm._i(_vm.provider.archived, null) > -1 : (_vm.provider.archived)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.provider.archived,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.provider, "archived", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.provider, "archived", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.provider, "archived", $$c)
        }
      }
    }
  }), _vm._v("\n          Archived\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Contract")]), _vm._v(" "), _c('input', {
    ref: "contract",
    attrs: {
      "type": "file",
      "id": "contract"
    },
    on: {
      "change": function($event) {
        return _vm.handleFileUploadContract()
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.contracts), function(contract, index) {
    return [_c('p', {
      staticClass: "control is-expanded"
    }, [_c('span', [_c('a', {
      attrs: {
        "href": contract.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(contract.file))]), _vm._v(" "), _c('a', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.removeContract(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])]
  }), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Contract Data")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provider.contract_data),
      expression: "provider.contract_data"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "contract_data",
      "id": "contract_data"
    },
    domProps: {
      "value": (_vm.provider.contract_data)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.provider, "contract_data", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.provider.new_provider_file === '' || _vm.provider.new_provider_file === null) ? [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("New Provider")]), _vm._v(" "), _c('input', {
    ref: "new_provider",
    attrs: {
      "type": "file",
      "id": "new_provider"
    },
    on: {
      "change": function($event) {
        return _vm.handleFileUploadNewProvider()
      }
    }
  })])] : [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("New Provider")]), _vm._v(" "), _c('span', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.new_provider()
      }
    }
  }, [_vm._v(_vm._s(_vm.provider.contract_file))]), _vm._v(" "), _c('a', {
    staticClass: "button is-small",
    on: {
      "click": _vm.changeContract
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])])], _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("EZ Company")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provider.ez_company),
      expression: "provider.ez_company"
    }],
    staticClass: "select is-fullwidth",
    attrs: {
      "name": "ez_company",
      "id": "ez_company"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.provider, "ez_company", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Ezlink - LDS Operadora")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Ezhotels")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Dehe Group")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("PMC")])])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Integration")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provider.integration),
      expression: "provider.integration"
    }],
    staticClass: "select is-fullwidth",
    attrs: {
      "name": "integration",
      "id": "integration"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.provider, "integration", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Web")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("XML")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("API")])])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Integrated system")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provider.integrated_system),
      expression: "provider.integrated_system"
    }],
    staticClass: "select is-fullwidth",
    attrs: {
      "name": "integrated_system",
      "id": "integrated_system"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.provider, "integrated_system", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wooba")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Cangooroo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Juniper")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Booking Motor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("TravelGate")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Infotera")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("Itravel")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("TravelTech")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("Nemo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Other")])])]), _vm._v(" "), (parseInt(_vm.provider.integrated_system) === 0) ? _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Other Integrated System")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provider.integrated_system_other),
      expression: "provider.integrated_system_other"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "integrated_system_other",
      "id": "integrated_system_other"
    },
    domProps: {
      "value": (_vm.provider.integrated_system_other)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.provider, "integrated_system_other", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provider.cross_selling),
      expression: "provider.cross_selling"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.provider.cross_selling) ? _vm._i(_vm.provider.cross_selling, null) > -1 : (_vm.provider.cross_selling)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.provider.cross_selling,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.provider, "cross_selling", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.provider, "cross_selling", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.provider, "cross_selling", $$c)
        }
      }
    }
  }), _vm._v("\n          Cross-Selling\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Training date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provider.training_date),
      expression: "provider.training_date"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "training_date",
      "id": "training_date"
    },
    domProps: {
      "value": (_vm.provider.training_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.provider, "training_date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Training participants")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provider.training_participants),
      expression: "provider.training_participants"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "training_participants",
      "id": "training_participants"
    },
    domProps: {
      "value": (_vm.provider.training_participants)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.provider, "training_participants", $event.target.value)
      }
    }
  })])], 2), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    class: {
      'button': true,
      'is-primary': true,
      'is-disabled': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.close(true)
      }
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    class: {
      'button': true,
      'is-success': true,
      'is-loading': _vm.inProgress
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29345c74","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/customer/ProviderRelationship.vue
// module id = 1089
// module chunks = 39